import { createSlice } from "@reduxjs/toolkit";

export const addPartnerSlice = createSlice({
  name: "addPartner",
  initialState: {
    partnerProfileData: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : null,
      partnerTypeId: "-1",
      partnerCategoryNo: "-1",
      companyNickname: "",
      tinNumber: "",
      // partnerStatus: "",
      address: "",
      zipCode: "",
      contactPerson: "",
      contactPerson2: "",
      contactPosition: "",
      contactPosition2: "",
      mobile: "",
      mobile2: "",
      landline: "",
      landline2: "",
      email: "",
      email2: "",
      ids: [],
      paymentScheduleNo: "",
      featuresCod: 0,
      featuresShipout: 0,
      featuresReturns: 0,
      statusComments: "",
      remarks: "",
      agentTopupAmount: 0,
      agentTopupSourceNo: -1,
      agentTopupThreshold: 0,
      agentFundSourceNo: 0,
      walletBalance: "",
      //   accessPermissions: [],
    },
  },
  reducers: {
    onPartnerProfileDataChange: (state, actions) => {
      console.log(actions.payload.name);
      console.log({ actions, state });
      const { name, value } = actions.payload;
      // let isOn = actions.payload.value === "on" ? 1 : 0;

      let tempPartnerProfileData = { ...state.partnerProfileData };
      console.log({ name, value });

      if (
        name === "featuresShipout" ||
        name === "featuresCod" ||
        name === "featuresReturns"
      ) {
        tempPartnerProfileData[name] = value === "on" ? 1 : 0;
      } else {
        tempPartnerProfileData[name] = value;
      }

      state.partnerProfileData = tempPartnerProfileData;
      console.log({ tempPartnerProfileData });
      // switch (actions.payload.name) {
      // 	case "partnerTypeId":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				partnerTypeId: actions.payload.value,
      // 			},
      // 		};
      // 	case "partnerCategoryNo":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				partnerCategoryNo: actions.payload.value,
      // 			},
      // 		};
      // 	case "companyNickname":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				companyNickname: actions.payload.value,
      // 			},
      // 		};
      // 	case "tinNumber": {
      // 		let regexTin = /^[0-9-]*$/;
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				tinNumber: actions.payload.value,
      // 			},
      // 		};
      // 	}
      // 	case "address":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				address: actions.payload.value,
      // 			},
      // 		};
      // 	case "zipCode": {
      // 		// Validate the zip code using the regex pattern
      // 		const zipCodeRegex = /^(?:[0-9]*)$/;
      // 		const isValidZipCode = zipCodeRegex.test(actions.payload.value);

      // 		if (!isValidZipCode) {
      // 			// If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
      // 			return {
      // 				...state, // Keep the current state
      // 				error: "Invalid zip code", // Add an error message
      // 			};
      // 		}

      // 		// If the zip code is valid, update the state
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				zipCode: actions.payload.value,
      // 			},
      // 			error: null, // Clear any previous error message
      // 		};
      // 	}
      // 	case "partnerStatus":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				partnerStatus: actions.payload.value,
      // 			},
      // 		};
      // 	case "contactPerson":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				contactPerson: actions.payload.value,
      // 			},
      // 		};
      // 	case "contactPerson2":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				contactPerson2: actions.payload.value,
      // 			},
      // 		};
      // 	case "contactPosition":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				contactPosition: actions.payload.value,
      // 			},
      // 		};
      // 	case "contactPosition2":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				contactPosition2: actions.payload.value,
      // 			},
      // 		};
      // 	case "mobile":
      // 		const regexMobile = /^[0-9]+$/;
      // 		const isValidMobile = regexMobile.test(actions.payload.value);
      // 		if (!isValidMobile) {
      // 			// If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
      // 			return {
      // 				...state, // Keep the current state
      // 				error: "Invalid", // Add an error message
      // 			};
      // 		}

      // 		// If the zip code is valid, update the state
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				mobile: actions.payload.value,
      // 			},
      // 			error: null, // Clear any previous error message
      // 		};
      // 	case "mobile2":
      // 		const regexMobile2 = /^[0-9]+$/;
      // 		const isValidMobile2 = regexMobile2.test(actions.payload.value);
      // 		if (!isValidMobile2) {
      // 			// If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
      // 			return {
      // 				...state, // Keep the current state
      // 				error: "Invalid", // Add an error message
      // 			};
      // 		}

      // 		// If the zip code is valid, update the state
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				mobile2: actions.payload.value,
      // 			},
      // 			error: null, // Clear any previous error message
      // 		};
      // 	case "landline": {
      // 		const regexLandline = /^[0-9-]*$/;
      // 		const isValidLandline = regexLandline.test(actions.payload.value);
      // 		if (!isValidLandline) {
      // 			// If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
      // 			return {
      // 				...state, // Keep the current state
      // 				error: "Invalid", // Add an error message
      // 			};
      // 		}

      // 		// If the zip code is valid, update the state
      // 		let formattedValue = actions.payload.value.replaceAll("-", "");

      // 		if (formattedValue.length === 11) {
      // 			formattedValue =
      // 				formattedValue.slice(0, 2) + "-" + formattedValue.slice(2);
      // 		} else if (formattedValue.length === 12) {
      // 			formattedValue =
      // 				formattedValue.slice(0, 3) + "-" + formattedValue.slice(3);
      // 		}
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				landline: formattedValue,
      // 			},
      // 			error: null, // Clear any previous error message
      // 		};
      // 	}
      // 	case "landline2": {
      // 		const regexLandline = /^[0-9-]*$/;
      // 		const isValidLandline = regexLandline.test(actions.payload.value);
      // 		if (!isValidLandline) {
      // 			// If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
      // 			return {
      // 				...state, // Keep the current state
      // 				error: "Invalid", // Add an error message
      // 			};
      // 		}

      // 		// If the zip code is valid, update the state
      // 		let formattedValue = actions.payload.value.replaceAll("-", "");

      // 		if (formattedValue.length === 11) {
      // 			formattedValue =
      // 				formattedValue.slice(0, 2) + "-" + formattedValue.slice(2);
      // 		} else if (formattedValue.length === 12) {
      // 			formattedValue =
      // 				formattedValue.slice(0, 3) + "-" + formattedValue.slice(3);
      // 		}
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				landline2: formattedValue,
      // 			},
      // 			error: null, // Clear any previous error message
      // 		};
      // 	}
      // 	case "email":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				email: actions.payload.value,
      // 			},
      // 		};
      // 	case "email2":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				email2: actions.payload.value,
      // 			},
      // 		};
      // 	case "ids":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				ids: actions.payload.value,
      // 			},
      // 		};
      // 	case "paymentScheduleNo":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				paymentScheduleNo: actions.payload.value,
      // 			},
      // 		};
      // 	case "featuresCod":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				featuresCod: actions.payload.checked ? 1 : 0,
      // 			},
      // 		};
      // 	case "featuresShipout":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				featuresShipout: actions.payload.checked ? 1 : 0,
      // 			},
      // 		};
      // 	case "featuresReturns":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				featuresReturns: actions.payload.checked ? 1 : 0,
      // 			},
      // 		};
      // 	case "remarks":
      // 		return {
      // 			...state,
      // 			partnerProfileData: {
      // 				...state.partnerProfileData,
      // 				remarks: actions.payload.value,
      // 			},
      // 		};
      // 	default:
      // 		return state;
      // }
    },
    onClearDataReducer: (state) => {
      state.partnerProfileData = {
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : null,
        partnerTypeId: "-1",
        partnerCategoryNo: "-1",
        companyNickname: "",
        tinNumber: "",
        // partnerStatus: "",
        address: "",
        zipCode: "",
        contactPerson: "",
        contactPerson2: "",
        contactPosition: "",
        contactPosition2: "",
        mobile: "",
        mobile2: "",
        landline: "",
        landline2: "",
        email: "",
        email2: "",
        ids: [],
        paymentScheduleNo: "",
        featuresCod: 0,
        featuresShipout: 0,
        featuresReturns: 0,
        statusComments: "",
        remarks: "",
        agentTopupAmount: 0,
        agentTopupSourceNo: -1,
        agentTopupThreshold: 0,
        agentSourceFundNo: 0,
        walletBalance: "",
        // accessPermissions: [],
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { onPartnerProfileDataChange, onClearDataReducer } =
  addPartnerSlice.actions;

export default addPartnerSlice.reducer;
